<input #input type="text" [readonly]="readonly" [ngModel]="value | percent" [ngModelOptions]="{updateOn:'blur'}"
    (ngModelChange)="_handleModelChange($event)" (focus)="_handleFocus()" (blur)="_handleBlur()"
    (keydown.enter)="blur()">